const style = {
    appBar: {
      position: 'fixed',
      top: 0,
      overflow: 'hidden',
      maxHeight: 57
    },
    menuButton: {
      marginLeft: 10
    },
    iconsRightContainer: {
      marginLeft: 20
    }
  };

export default style;


// WEBPACK FOOTER //
// ./src/containers/layout/styles/headerStyles.js